import React from 'react';

type Props = {step: number};

export default function RegistrationStep({step}: Props) {
  if (step === 2) {
    return (
      <div className='flex space-x-2 w-full pb-4 px-8 z-[1]'>
        <div className='grow h-2 bg-gray-200 rounded-full'></div>
        <div className='grow h-2 bg-[#318EE2] rounded-full'></div>
      </div>
    );
  }

  return (
    <div className='flex space-x-2 w-full pb-4 px-8 z-[1]'>
      <div className='grow h-2 bg-[#318EE2] rounded-full'></div>
      <div className='grow h-2 bg-gray-700 rounded-full'></div>
    </div>
  );
}
